import React from 'react';
import { ToggleButtonGroup, ToggleButton } from '@mui/material';
import { colors } from '../../css';

export default function SwitchGroup({ selectedOption, setSelectedOption, options }) {

  const handleUnitChange = (event, newUnit) => {
    console.log(newUnit)
    if (newUnit !== null) {
      setSelectedOption(newUnit)
    }
  }

  return (
    <>
      <ToggleButtonGroup
        exclusive
        size={'small'}
        value={selectedOption}
        onChange={handleUnitChange}
        style={{ marginLeft: '5px' }}
      >
        {options.map(option => {
          return (
            <ToggleButton value={option}
              style={{
                padding: '0 5px',
                backgroundColor: selectedOption === `${option}` ? `${colors.colorBlue}` : `${colors.colorWhite}`,
                color: selectedOption === `${option}` ? `${colors.colorWhite}` : `${colors.colorBlack}`,
              }}>
              {option}
            </ToggleButton>
          )
        })}
      </ToggleButtonGroup>
    </>

  )
}